import PropTypes from "prop-types";
import React, { Component, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";

//Import images
import avatar3 from "../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../assets/images/users/avatar-4.jpg";

//i18n
import { withTranslation } from "react-i18next";
import styled from "styled-components";

const NotificationDropdown = props => {
  const [isOpen, setIsOen] = useState(false);
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    if (props.data?.length > 0) {
      let count = 0;
      props.data.map(i => {
        !i.reviewed && count++;
      });
      setCounter(count);
    }
  }, [props.data]);

  const toggle = () => {
    setIsOen(!isOpen);
  };

  const dateFormatter = val => {
    let date = new Date(val).toJSON().split("T");
    return `${date[0]} (${date[1].replace(/\..*/, "")})`;
  };

  const onSelectNotify = (event, vals) => {
    if (!vals.reviewed) {
      let dt = vals;
      dt.reviewed = true;
      props.updateNotifications(dt);
    }
  };

  const handleViewAllNotify = () => {
    props.updateAllNotifications();
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isOpen}
        toggle={toggle}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className={`bx bx-bell ${counter > 0 ? "bx-tada" : ""}`} />
          <span
            className={`badge bg-danger rounded-pill ${
              counter <= 0 ? "d-none" : ""
            }`}
          >
            {counter}
          </span>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> {props.t("Notifications")} </h6>
              </Col>
              <div className="col-auto">
                <a
                  href="#"
                  className="small"
                  onClick={() => handleViewAllNotify()}
                >
                  {" "}
                  View All
                </a>
              </div>
            </Row>
          </div>

          <SimpleBar
            style={{
              maxHeight: "230px",
              height: "100%",
              overflow: props.data.length <= 0 && "hidden",
            }}
          >
            {props.data.length > 0 ? (
              props.data.map((i, k) => (
                <StyledCard key={k} className="">
                  <Link
                    key={k}
                    to={`/offers/${i.entity_id}`}
                    className="text-reset notification-item"
                  >
                    <StyledLink
                      onClick={e => onSelectNotify(e, i)}
                      className="media"
                      style={{
                        background: !i.reviewed ? "#0088db24" : "transparent",
                      }}
                    >
                      <div className="avatar-xs me-3">
                        <span className="avatar-title bg-primary rounded-circle font-size-16">
                          <i className="bx bx-detail" />
                        </span>
                      </div>
                      <div className="media-body">
                        {/* <h6 className="mt-0 mb-1">
                      {props.t("Your order is placed")}
                    </h6> */}
                        <div className="font-size-14 text-muted">
                          <p className="mb-1">{i.message}</p>
                          <p className="mb-0 font-size-10">
                            <i className="mdi mdi-clock-outline" />{" "}
                            {dateFormatter(i.create_time)}
                          </p>
                        </div>
                      </div>
                    </StyledLink>
                  </Link>
                  <ClearStyle onClick={() => props.deleteNotification(i.id)}>
                    <span>
                      <i className="bx bx-trash" />
                    </span>
                  </ClearStyle>
                </StyledCard>
              ))
            ) : (
              <Row
                className="align-items-center text-center my-4"
                // style={{ height: 179 }}
              >
                <Col xs={12}>
                  <i
                    className="dripicons-archive"
                    style={{ fontSize: "40px", opacity: "0.2" }}
                  />
                  <p style={{ opacity: "0.2" }}>Notifications is empty</p>
                </Col>
              </Row>
            )}
            {/*             
            <Link to="" className="text-reset notification-item">
              <div className="media">
                <img
                  src={avatar3}
                  className="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div className="media-body">
                  <h6 className="mt-0 mb-1">James Lemire</h6>
                  <div className="font-size-12 text-muted">
                    <p className="mb-1">
                      {props.t("It will seem like simplified English") + "."}
                    </p>
                    <p className="mb-0">
                      <i className="mdi mdi-clock-outline" />
                      {props.t("1 hours ago")}{" "}
                    </p>
                  </div>
                </div>
              </div>
            </Link>
            <Link to="" className="text-reset notification-item">
              <div className="media">
                <div className="avatar-xs me-3">
                  <span className="avatar-title bg-success rounded-circle font-size-16">
                    <i className="bx bx-badge-check" />
                  </span>
                </div>
                <div className="media-body">
                  <h6 className="mt-0 mb-1">
                    {props.t("Your item is shipped")}
                  </h6>
                  <div className="font-size-12 text-muted">
                    <p className="mb-1">
                      {props.t("If several languages coalesce the grammar")}
                    </p>
                    <p className="mb-0">
                      <i className="mdi mdi-clock-outline" />{" "}
                      {props.t("3 min ago")}
                    </p>
                  </div>
                </div>
              </div>
            </Link>
            <Link to="" className="text-reset notification-item">
              <div className="media">
                <img
                  src={avatar4}
                  className="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div className="media-body">
                  <h6 className="mt-0 mb-1">Salena Layfield</h6>
                  <div className="font-size-12 text-muted">
                    <p className="mb-1">
                      {props.t(
                        "As a skeptical Cambridge friend of mine occidental"
                      ) + "."}
                    </p>
                    <p className="mb-0">
                      <i className="mdi mdi-clock-outline" />
                      {props.t("1 hours ago")}{" "}
                    </p>
                  </div>
                </div>
              </div>
            </Link> */}
          </SimpleBar>
          <div className="p-2 border-top d-grid d-none">
            <Link
              className="btn btn-sm btn-link font-size-14 text-center"
              to="#"
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>{" "}
              <span key="t-view-more">{props.t("View More..")}</span>
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

const StyledCard = styled.div`
  position: relative;
`;

const ClearStyle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 25px;
  background: rgba(205, 205, 205, 0.7);
  position: absolute;
  top: 33px;
  right: 8px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  text-align: center;
  vertical-align: middle;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  span {
    opacity: 1;
    width: 20px;
    display: flex;
    justify-content: center;
    transition: all 0.2s ease-in-out;

    i {
      color: rgba(139, 139, 139, 0.7);
    }
  }

  &:hover {
    background: rgba(205, 205, 205, 1);
    span {
      i {
        color: rgba(139, 139, 139, 1);
      }
    }
  }
`;

const StyledLink = styled.div`
  transition: background 0.3s ease-in-out;
  &:hover {
    background: #f6f6f6 !important;
  }
`;

NotificationDropdown.propTypes = {
  t: PropTypes.any,
  data: PropTypes.array,
  updateAllNotifications: PropTypes.func.isRequired,
  updateNotifications: PropTypes.func.isRequired,
  deleteNotification: PropTypes.func.isRequired,
};

export default withTranslation()(NotificationDropdown);
